import PricingDisplay from './PricingDisplay'

export default PricingDisplay
